import React from 'react';
import { Badge } from './Badge';
import { statusClass, statusDot, statusLabel, type AttendanceStatus } from '../../utils/attendance';
export function StatusBadge({
  status,
  odstotek,
  showPercent = true
}: {
  status: AttendanceStatus;
  odstotek: number | null;
  showPercent?: boolean;
}) {
  if (status === 'premalo') {
    return <Badge className={statusClass.premalo} dot={statusDot.premalo} data-id="element-460" data-mp="198vu7x7yug7t">
        Premalo podatkov
      </Badge>;
  }
  return <Badge className={statusClass[status]} dot={statusDot[status]} data-id="element-461" data-mp="26sqieye5u698">
      {showPercent && odstotek !== null ? `${odstotek} % · ` : ''}
      {statusLabel[status]}
    </Badge>;
}